import React from "react";
import LiveScheduleGroupContext from '../../LiveScheduleGroupContext.js';

/**
 * Renders all the workers in the group for live  schedules.
 * @param {*} param0
 */

const groupRendererLive = (group, props) => {
  return (
      <LiveScheduleGroupContext
        group={group}
        startDate={props.startDate}
        updateOptimisticLiveSchedule={props.updateOptimisticLiveSchedule}
      />
  );
};

export default groupRendererLive;
